import { jsx as _jsx } from "react/jsx-runtime";
import EnvironmentSelection from '../../components/auth/EnvironmentSelection';
/**
 * Render environment selection screen (without OIDC provider)
 * Used when no environment is selected or localStorage is unavailable (e.g., incognito mode)
 */
export function renderEnvironmentSelection(root, hostType) {
    console.log('[Init] Rendering environment selection (no auth context required)');
    const handleEnvironmentSelect = () => {
        // Reload the page to trigger bootstrap with the new environment
        console.log('[Init] Environment selected, reloading page...');
        window.location.reload();
    };
    root.render(_jsx("div", { className: "h-full", children: _jsx(EnvironmentSelection, { onEnvironmentSelect: handleEnvironmentSelect, hostType: hostType }) }));
}
